// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector('.loading__spinner');
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio, overlay) {
  // calculate mouse position relative to the image element
  const ratio = image.height / image.width;
  const container = image.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio, overlay);
  overlay.onmouseleave = () => overlay.remove();
  return overlay;
}

function enableZoomOnHover(zoomRatio) {
  /**
   * Strategy: attach a CAPTURE-phase listener on each `.product__modal-opener--image`
   * element. Capture fires top-down, so it runs BEFORE:
   *   - the ModalOpener's button click listener (bubble phase)
   *   - the SliderComponent's capture listener (registered later in the tree)
   * Calling stopImmediatePropagation() prevents both from firing.
   *
   * This works for both desktop (button hidden by @media (hover:hover), img receives click)
   * and mobile (button::after covers area, but we intercept at modal-opener level first).
   */
  const openers = document.querySelectorAll('.product__modal-opener--image');

  openers.forEach((opener) => {
    // Clean up any previously attached handler to prevent stacking on variant changes
    if (opener._magnifyHandler) {
      opener.removeEventListener('click', opener._magnifyHandler, true);
    }

    opener._magnifyHandler = (event) => {
      // If a zoom overlay is already visible, clicking anywhere in the opener
      // should close it (zoom out) — not create another one.
      const existingOverlay = opener.querySelector('.image-magnify-full-size');
      if (existingOverlay) {
        event.preventDefault();
        event.stopImmediatePropagation();
        existingOverlay.remove();
        return;
      }

      const image = opener.querySelector('.image-magnify-hover');
      if (!image) return;

      // Prevent modal from opening and stop any other click handlers
      event.preventDefault();
      event.stopImmediatePropagation();

      const overlay = magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio, overlay);
    };

    // true = capture phase — fires before any bubble-phase listeners on children
    opener.addEventListener('click', opener._magnifyHandler, true);
  });
}

enableZoomOnHover(2);
